import React, { useEffect, useMemo, useState } from 'react'
import { const_var, params } from '../../../../../redux/reducers/reducer'
import WallNameTemplete from '../../../WallName/WallNameTemplete';

const WallName = () => {
    const [porchOffset, setPorchOffset] = useState(0);

    const frontRightPosState = useMemo(() => {
        let offset = false;
        if((params.leanF_p_w && params.leanR_p_w) < 9) {
            if((params.leanF_p_pos + params.leanF_p_d / 2 + 2.5 > params.p_w / 2 + 1) && (params.leanR_p_pos + params.leanR_p_d / 2 + 2.5 > params.p_d / 2 + 1)){
                offset = true;
            }
        }
        
        return offset;
    }, [params.leanF_p_pos, params.leanF_p_d, params.p_w, params.leanR_p_pos, params.leanR_p_d, params.p_d, params.leanF_p_w, params.leanR_p_w])

    const backRightPosState = useMemo(() => {
        let offset = false;
        if((params.leanB_p_w && params.leanR_p_w) < 9) {
            if((params.leanB_p_pos + params.leanB_p_d / 2 + 2.5 > params.p_w / 2 + 1) && (params.leanR_p_pos - params.leanR_p_d / 2 - 2.5 < -(params.p_d / 2 + 1))){
                offset = true;
            }
        }
        
        return offset;
    }, [params.leanB_p_pos, params.leanB_p_d, params.p_w, params.leanR_p_pos, params.leanR_p_d, params.p_d, params.leanB_p_w, params.leanR_p_w])

    useEffect(() => {
        if(params.add_right_front_lean_porch && !params.add_right_back_lean_porch) {
            setPorchOffset(params.leanF_p_w / 2)
        } else if(!params.add_right_front_lean_porch && params.add_right_back_lean_porch){
            setPorchOffset(-params.leanB_p_w / 2)
        } else {
            setPorchOffset(0)
        }
    }, [params.add_right_front_lean_porch, params.add_right_back_lean_porch, params.leanF_p_w, params.leanB_p_w])



    let wallTemplates = [
        { position: [(params.p_w / 2 + params.leanR_p_w + 1), 0, porchOffset], rotation: [0, Math.PI / 2, 0], slopeAngle: 60, value: 'Right Lean Side' },
        { position: [(params.p_w / 2 + params.leanR_p_w / 2), frontRightPosState ? 0.7 : 0, params.leanR_p_d / 2 + (frontRightPosState ? -0.5 : 1)], slopeAngle: (frontRightPosState ? 0: 60), rotation: [0, 0, 0], value: 'Right Lean Front' },
        { position: [(params.p_w / 2 + params.leanR_p_w / 2), backRightPosState ? 0.7 : 0, -(params.leanR_p_d / 2 + (backRightPosState ? -0.5 : 1))], rotation: [0, Math.PI, 0], slopeAngle: (backRightPosState ? 0 : 60), value: 'Right Lean Back' }
    ]
    if(params.add_storage_check_right){
        if(params.rightLeanStoragePosition != 0){
            let positionZ = (params.rightLeanStoragePosition!=0)?-(params.leanR_p_d / 2 - Math.round(params.rightLeanStoragePosition)): -(params.leanR_p_d / 2  - parseInt(params.add_storage_right))  
            let rightFront =  {
                 position: [(params.p_w / 2 + params.leanR_p_w / 2), 0, positionZ], 
                 rotation: [0, Math.PI, 0], 
                 slopeAngle: 60,
                 value:'Right Lean Storage Back' 
                };
            wallTemplates =[...wallTemplates,rightFront]
        }
        if(params.rightLeanStoragePosition != params.leanR_p_d - parseInt(params.add_storage_right)){
            let positionZ = (params.rightLeanStoragePosition!=0)?-(params.leanR_p_d / 2  - parseInt(params.add_storage_right) - Math.round(params.rightLeanStoragePosition)): -(params.leanR_p_d / 2  - parseInt(params.add_storage_right))  
            let rightFront =  {
                 position: [(params.p_w / 2 + params.leanR_p_w / 2), 0, positionZ], 
                 rotation: [0, 0, 0], 
                 slopeAngle: 60,
                 value:'Right Lean Storage Front' 
                };
            wallTemplates =[...wallTemplates,rightFront]
        }
    }
    return (
        <>
            {wallTemplates.map((template, index) => (
                <WallNameTemplete
                    key={index}
                    position={template.position}
                    rotation={template.rotation}
                    value={template.value}
                    slopeAngle={template.slopeAngle}
                />
            ))}
        </>
    )
}

export default WallName